import React, { useState } from 'react'
import { useNavigate  , useParams} from 'react-router-dom'

//URL
import{URL} from '../../../context/URL'

//SweetAlrt
import {SweetAlrt} from '../../../context/SweetAlrt'

//Incript_password
import {Incript_password} from '../../../context/Incript_password'

//mui
import { TextField } from '@mui/material';

export default function Forget_password() {
    const navigate = useNavigate();
    const {email} = useParams();

   const [password , setPassword] = useState({newPassword : "" , confromPassword : ""});
  const [password_lengthAlert , setPassword_lengthAlert] = useState(false);
  const [confrom_passwordAlert , setConfrom_passwordAlert] = useState(false);

    const handle_forgetPassword = ()=>{
        if(password.newPassword.length >= 4){
            setPassword_lengthAlert(false);
            if(password.newPassword == password.confromPassword){
                setConfrom_passwordAlert(false);
                

                try{
                    let incript_password = Incript_password(password.confromPassword);
                    fetch(`${URL}/user/forgetPassword/${email}` , {
                        method : "PUT",
                        body : JSON.stringify({password :incript_password}),
                        headers : {
                            "content-type" : "application/json"
                        }
                    })
                 
                    SweetAlrt("Password Update " , "success");
                    navigate('/')
                }catch(error){
                    console.log("forget password api error : " + error);
                    SweetAlrt("Password Update " , "error");
                    // SweetAlrt("OTP send ") 
                }

                
            }else{
                setConfrom_passwordAlert(true);
            }

        }else{
            setPassword_lengthAlert(true);
        }
        
    }

  return (
    <>
    <div className="container" style={{background :  '#f2f2f2' }}>
        <div className="wrapper" style={{ background : '#FFFF' }}>
            <div className="title"><span>Foreget password </span></div>
            <form>
           
            {/* <div className="row">
               <i className="fas fa-lock"></i>
                <input type="text"  placeholder="new password" onChange={(e)=>setPassword({...password , newPassword : e.target.value})} required/>
            </div> */}


            <div style={{marginBottom : '1rem'}}>
                {
                    password_lengthAlert ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Password"
                    type='password'
                    onChange={(e)=>setPassword({...password , newPassword : e.target.value})}
                    helperText="must be password length 4"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="Password"
                        type='password'
                        onChange={(e)=>setPassword({...password , newPassword : e.target.value})}
                    />
                }
             </div>

            {/* <div className="row">
               <i className="fas fa-lock"></i>
                <input type="text"  placeholder="confrom password" onChange={(e)=>setPassword({...password , confromPassword : e.target.value})} required/>
            </div> */}

            <div style={{marginBottom : '1rem'}}>
                {
                    confrom_passwordAlert ?  <TextField
                    error
                    color='info'
                    style={{width : '100%'}}
                    id="outlined-error"
                    label="Confrom Password"
                    onChange={(e)=>setPassword({...password , confromPassword : e.target.value})}
                    helperText="Password not match"
                    /> 
                    :
                    <TextField
                        // error
                        color='info'
                        style={{width : '100%'}}
                        id="outlined-error"
                        label="Confrom Password"
                        onChange={(e)=>setPassword({...password , newPassword : e.target.value})}
                    />
                }
             </div>
           
            <div className="row button">
                <input type="button" value="Update" onClick={handle_forgetPassword}/>
            </div>
            </form>
        </div>
        </div>
    </>
  )
}
